<ng-container *ngIf="!isTextOnly; else textOnly">
    <ng-content></ng-content>
</ng-container>

<ng-template #textOnly>
    <span class="text-neutral-600 f-small">{{text}}</span>
</ng-template>


